import { Option } from '@common/types';

export const createArrayValuesFromSelectOptions = (data: Option[] | number) => {
  if (!data) return undefined;
  if (typeof data !== 'object') return data;
  return data?.some((type: string | object) => typeof type === 'object') ? data.map(({ value }) => value) : data;
};
